export default {
  accountIdentity: '帳戶身份', account: 'GGMOMOMO 帳戶', signedIn: '已登入', notSignedIn: '尚未登入',
  signOut: '登出 GGMOMOMO 帳戶', walletStatus: '錢包資訊', walletInfo: '錢包資訊', worldAppWallet: 'World App 錢包',
  metaMaskConnection: 'MetaMask 錢包連接', worldChainConnected: 'World Chain · 已連接', noAddress: '尚未取得地址',
  disconnecting: '中斷中…', disconnectMetaMask: '中斷 MetaMask 連接', language: '程式語言',
  languageDescription: '選擇 Bubble Wallet 使用的介面語言。',
  legal: '法律文件', legalDocuments: '法律文件', privacyPolicy: '私隱政策', termsOfUse: '使用條款',
} as const;
